import React, {useState, useEffect} from 'react';
import { Link, useParams } from 'react-router-dom';
import '../styles/global.css';
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import Lancamento from './Forms/Lancamento';
import { useNavigate } from 'react-router-dom';

function Lancamentos() {

    const { idPrestacaoDeContas } = useParams();
    const [lancamentos, setLancamentos] = useState([]);
    const [modalInfo, setModalInfo] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectStatus, setSelectStatus] = useState('');
    const [isLoadingMOD, setIsLoadingMOD] = useState(false);

    const [menuAberto, setMenuAberto] = useState(false);
    const associado = parseInt(sessionStorage.getItem('pesAssociado'));
        //era localStorage.getItem('pesAssociado') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente
    const navigate = useNavigate();
    const loggedIn = sessionStorage.getItem('loggedIn');
        //era localStorage.getItem('loggedIn') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente
    useEffect(() => {
        if (loggedIn === false || loggedIn === null || loggedIn === undefined || idPrestacaoDeContas === undefined || idPrestacaoDeContas === null)
        {
            navigate('/Login');
            window.location.reload();
        }
    }, []);

    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    
    const customFormatSmallDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    

    useEffect(() => {
        var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        setIsLoadingMOD(true);

        const prestacao = {
            IdPrestacaoDeContas: idPrestacaoDeContas,
        }

        let url = process.env.REACT_APP_API_URL + '/routes.php?metodo=obtemTodosLancamentos';
        if (idPrestacaoDeContas > 0) {
            url = process.env.REACT_APP_API_URL + `/routes.php?metodo=obtemLancamentos`;
        }

        axios
            .post(url, prestacao, {
                headers: {
                    "X-Access-Token": token,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            })
            .then(response => {
                if(response.message === 'Nenhum resultado encontrado.'){
                    setIsLoadingMOD(false);
                    setLancamentos([]);
                    return;
                }
                else {
                    setLancamentos(response.data);
                    setIsLoadingMOD(false)
                }
                
            })
            .catch(error => {
                let ret = error.message;
                setIsLoadingMOD(false);
                if (ret.includes("401")) {
                    console.log("token inválido!")
                } else if (ret.includes("403")) {
                    //window.location.reload();
                }
            })
    }, [])

    //console.log(lancamentos);

    function handleSelectStatusChange(event) {
        sessionStorage.selectStatusRegistroLancamentos = event.target.value;
        setSelectStatus(sessionStorage.selectStatusRegistroLancamentos);
    }

    function handleNovoCadastro() {
        const lancamento = {
            IdLancamento: 0,
            IdPrestacaoDeContas: idPrestacaoDeContas,
            lanDescricao: '',
            lanTipo: 'Despesa',
            lanValor: '0',
            lanData: customFormatSmallDate,
            lanDocumento: '',
            lanObservacao: '',
            lanStatus: 1,
            lanCriadoPor: '',
            lanCriadoEm: customFormatDate,
            lanAlteradoPor: '',
            lanAlteradoEm: customFormatDate,
            lanCodigoGUID: ''
        }
        // setModalOpen(false);
        // setModalInfo(lancamento);
        //localStorage.setItem('lancamento', JSON.stringify(lancamento));
        navigate('/Lancamento', { state: { lancamentoInfo: lancamento } });
    }

    function handleEditCadastro(lancamento) {
        // setModalInfo(lancamento);
        // setModalOpen(true);
        navigate(`/Lancamento`, { state: { lancamentoInfo: lancamento } });
        //window.location.reload();
    }

    function handleVoltarCadastro() {
        //setModalOpen(false);
        navigate(-1);
    }

    function handleExibirPDF(lancamento) {
        //console.log(lancamento);
        //return;
        navigate(`/ViewPDF`, { state: { registro: lancamento } });
    }


  //salvar log de navegação
  useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Navegação",
      logModulo: "Página de Lançamentos",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
  }, []);

    //identificar a resolução da tela para ajustar o tamanho da tabela
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
        setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

//console.log(lancamentos);
    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div>
                    {/* Titulos da página */}
                    <div className='headerMain'>
                        <label className='labelTitulo' >FINANCEIRO</label>
                        <label className='labelSubTitulo'>Lançamentos</label>
                    </div>
                    {/* Modal de edição */}
                    <div>
                        {modalOpen && (<Lancamento setOpenModal={setModalOpen} lancamentoInfo={modalInfo} />)}
                    </div>
                    {/* Pesquisa filtro e Novo */}
                    <div className="containerBarraPesquisa">
                    
                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                            <button className="buttonModalPadrao" onClick={handleNovoCadastro}>
                                NOVO REGISTRO
                            </button> ) : ('')}
                        

                        <input className="inputBarraPesquisa"
                        placeholder="PESQUISAR"
                        type="text"
                        id="inputPesquisa"
                        name="inputPesquisa"
                        onChange={event => {
                            setSearchTerm(event.target.value)
                        }}
                        />
                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        <select className="selectStatusPesquisa"
                        name="selectStatusRegistroLancamentos"
                        selected={sessionStorage.selectStatusRegistroLancamentos !== undefined ? sessionStorage.selectStatusRegistroLancamentos : '99'}
                        onChange={event => {
                            handleSelectStatusChange(event)
                        }}
                        >
                        <option value={'99'} selected={sessionStorage.selectStatusRegistroLancamentos === '99'} >TODOS</option>
                        <option value={'1'} selected={sessionStorage.selectStatusRegistroLancamentos === '1'} >ATIVOS</option>
                        <option value={'0'} selected={sessionStorage.selectStatusRegistroLancamentos === '0'} >INATIVOS</option>
                        </select>
                        ) : ('')}
                        <div>
                            <button className="buttonModalPadrao" onClick={handleVoltarCadastro}>
                                VOLTAR
                            </button>
                        </div>
                    </div>

                    {/* Tabela de Lançamentos */}
                    <div className="tabelaPadrao">
                        {windowWidth < 768 ? (
                                lancamentos
                                .filter(val => {
                                    if (searchTerm === '') {
                                        if(sessionStorage.selectStatusRegistroLancamentos !== undefined && sessionStorage.selectStatusRegistroLancamentos === '99')
                                        {
                                            return val
                                        }
                                        else if (sessionStorage.selectStatusRegistroLancamentos !== undefined && sessionStorage.selectStatusRegistroLancamentos !== '99')
                                        {
                                            if(parseInt(sessionStorage.selectStatusRegistroLancamentos) === parseInt(val.lanStatus))
                                            {
                                            return val
                                            }
                                        }
                                        else{
                                            return val
                                        }
                                    } else if (
                                        val.lanData
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase())
                                        ||
                                        val.lanDescricao
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase())
                                        ||
                                        val.lanTipo
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase())
                                        ||
                                        val.lanValor
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase())
                                    ) {
                                        if(sessionStorage.selectStatusRegistroLancamentos !== undefined && sessionStorage.selectStatusRegistroLancamentos === '99')
                                        {
                                            return val
                                        }
                                        else if (sessionStorage.selectStatusRegistroLancamentos !== undefined && sessionStorage.selectStatusRegistroLancamentos !== '99')
                                        {
                                            if(parseInt(sessionStorage.selectStatusRegistroLancamentos) === parseInt(val.lanStatus))
                                            {
                                            return val
                                            }
                                        }
                                        else{
                                            return val
                                        }
                                    }
                                })
                                .map(lancamento => (
                                    <div style={{borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '10px' }}>
                                        <div 
                                        key={lancamento.IdLancamento} 
                                        onClick={() => handleEditCadastro(lancamento)}
                                        className="p2" style={{ cursor: 'pointer' }}
                                        >
                                        <div>
                                            <p style={{ color: '#000' }}><b>DATA:</b> { new Intl.DateTimeFormat('pt-BR').format(new Date(lancamento.lanData))} </p>
                                            <p style={{ color: '#000', marginTop: '10px'  }}><b>DESCRIÇÃO:</b> {lancamento.lanDescricao} </p>
                                            <p style={{ color: '#000', marginTop: '10px'  }}><b>TIPO:</b> {lancamento.lanTipo} </p>
                                            <p style={{ color: '#000', marginTop: '10px'  }}><b>VALOR:</b> {lancamento.lanValor} </p>
                                            <p style={{ color: '#000', marginTop: '10px'  }}><b>STATUS:</b> {parseInt(lancamento.lanStatus) === 1 ? 'ATIVO' : 'INATIVO'} </p>
                                        </div>
                                        
                                        <div style={{ marginTop: '10px' }} >
                                            {lancamento.lanDocumento ? (
                                                <button className="buttonGridPadrao" onClick={(e) => { e.stopPropagation(); handleExibirPDF(lancamento); }}>
                                                    Documento
                                                </button>
                                            ) : (
                                                <span className="cardLancamentoValue">N/A</span>
                                            )}
                                        </div>
                                    </div>
                                    </div>
                                ))
                        ) : (
                        <table>
                            <thead>
                                <tr>
                                    <th className='tdAlignCenter'>
                                    DATA
                                    </th>
                                    <th className='tdAlignLeft'>
                                    DESCRIÇÃO
                                    </th>
                                    <th className='tdAlignLeft'>
                                    TIPO
                                    </th>
                                    <th className='tdAlignLeft'>
                                    VALOR
                                    </th>
                                    <th className='tdAlignCenter'>
                                    DOCUMENTO
                                    </th>
                                    <th className='tdAlignCenter'>
                                    STATUS
                                    </th>
                                </tr>
                            </thead>
                            {isLoadingMOD ? <td colSpan="5" style={{ width: "100%", textAlign: "center"}}><CircularProgress /></td> :
                            lancamentos.length === null ? <td colSpan="5" style={{ width: "100%", textAlign: "center"}}></td> :
                            lancamentos.message === 'Nenhum resultado encontrado.' ? <td colSpan="5" style={{ width: "100%", textAlign: "center"}}></td> :
                            lancamentos
                            .filter(val => {
                                if (searchTerm === '') {
                                    //return val
                                    if(sessionStorage.selectStatusRegistroLancamentos !== undefined && sessionStorage.selectStatusRegistroLancamentos === '99')
                                    {
                                        return val
                                    }
                                    else if (sessionStorage.selectStatusRegistroLancamentos !== undefined && sessionStorage.selectStatusRegistroLancamentos !== '99')
                                    {
                                        if(parseInt(sessionStorage.selectStatusRegistroLancamentos) === parseInt(val.lanStatus))
                                        {
                                        return val
                                        }
                                    }
                                    else{
                                        return val
                                    }
                                } else if (
                                    val.lanData
                                    .toLowerCase()
                                    .includes(searchTerm.toLowerCase())
                                    ||
                                    val.lanDescricao
                                    .toLowerCase()
                                    .includes(searchTerm.toLowerCase())
                                    ||
                                    val.lanTipo
                                    .toLowerCase()
                                    .includes(searchTerm.toLowerCase())
                                    ||
                                    val.lanValor
                                    .toLowerCase()
                                    .includes(searchTerm.toLowerCase())
                                ) {
                                    if(sessionStorage.selectStatusRegistroLancamentos !== undefined && sessionStorage.selectStatusRegistroLancamentos === '99')
                                    {
                                        return val
                                    }
                                    else if (sessionStorage.selectStatusRegistroLancamentos !== undefined && sessionStorage.selectStatusRegistroLancamentos !== '99')
                                    {
                                        if(parseInt(sessionStorage.selectStatusRegistroLancamentos) === parseInt(val.lanStatus))
                                        {
                                        return val
                                        }
                                    }
                                    else{
                                        return val
                                    }
                                }
                            })
                            .map(lancamento => (
                                <tr key={lancamento.IdLancamento} >
                                    <td className='tdAlignCenter' onClick={() => handleEditCadastro(lancamento)}>
                                        { new Intl.DateTimeFormat('pt-BR').format(new Date(lancamento.lanData))}
                                    </td>

                                    <td style={{textTransform: 'uppercase'}} onClick={() => handleEditCadastro(lancamento)}>
                                        {lancamento.lanDescricao}
                                    </td>

                                    <td style={{textTransform: 'uppercase'}} onClick={() => handleEditCadastro(lancamento)}>
                                        {lancamento.lanTipo}
                                    </td>

                                    <td style={{textTransform: 'uppercase'}} onClick={() => handleEditCadastro(lancamento)}>
                                        {lancamento.lanValor}
                                    </td>

                                    <td className='tdAlignCenter'
                                        onClick={lancamento.lanDocumento 
                                    ? () => handleExibirPDF(lancamento) : null} >
                                        {lancamento.lanDocumento ? 
                                        <button className="buttonGridPadrao" >
                                            Documento
                                        </button> : ''}
                                    </td>
                                        
                                    <td width={40} className='tdAlignCenter' onClick={() => handleEditCadastro(lancamento)}>
                                        <label className="btnMGUPermissoes" >
                                        <input
                                            type="checkbox"
                                            defaultChecked={!!lancamento.lanStatus}
                                            disabled
                                        />
                                        {/* <span className="checkmark"></span> */}
                                        </label>
                                    </td>
                                </tr>
                            ))}
                        </table>
                        )}
                    </div>
                    
                </div>
            </main>
        </div>
    )
}

export default Lancamentos;

